export default __webpack_public_path__ + "static/property01-46bb9c3e9140600c5bc3953fc6cd3b6a.jpg";